"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localIdRef = exports.uriRef = exports.idRef = void 0;
/**
 * Creates an IdentifierRef from object identifier and optionally the object type.
 *
 * @remarks see {@link IdentifierRef} for more information about identifier references
 *
 * @param identifier - identifier to use
 * @param type - referenced object type
 * @returns identifier reference
 * @public
 */
function idRef(identifier, type) {
    return type ? { identifier: identifier, type: type } : { identifier: identifier };
}
exports.idRef = idRef;
/**
 * Creates an UriRef from an URI
 * @param uri - URI to use
 * @returns uri reference
 * @public
 */
function uriRef(uri) {
    return { uri: uri };
}
exports.uriRef = uriRef;
/**
 * Creates an LocalIdRef from a local identifier
 * @param localIdentifier - local identifier to use
 * @returns local identifier reference
 * @public
 */
function localIdRef(localIdentifier) {
    return { localIdentifier: localIdentifier };
}
exports.localIdRef = localIdRef;
//# sourceMappingURL=factory.js.map